module.exports = __webpack_public_path__ + "img/nt53-04-80-1.prt.5a713437.jpg";